const MINDKEY_API_BASE = 'https://recruiting.mindkey.com/api';

export const getDetailedVacancyFromMindkey = async ({
	customerId,
	id,
	locale,
}: {
	customerId: string;
	id: string;
	locale: string;
}): Promise<Mindkey.VacancyDetail> => {
	const VACANCY_QUERY_PARAMS = new URLSearchParams({
		showStartDate: 'Hide',
		showEndDate: 'Hide',
		showVacancyType: 'Hide',
		showContactPersonName: 'Show',
		showContactPersonWorkPhone: 'Show',
		showContactPersonMobilePhone: 'Show',
		showContactPersonEmail: 'Show',
		showPositionStartDate: 'Hide',
		showEmploymentCategoryName: 'Hide',
		showOrganizationName: 'Hide',
		showLocations: 'Hide',
		showRegions: 'Show',
		showTeaser: 'Hide',
		showCompanyName: 'Hide',
		showCompanyAddress: 'Hide',
		showLongDate: 'false',
		showImage: 'false',
	}).toString();

	const url = `${MINDKEY_API_BASE}/${customerId}/vacancies/${encodeURIComponent(id)}?${VACANCY_QUERY_PARAMS}`;
	try {
		const response = await fetch(url, { headers: { 'x-mindkey-user-language': locale } });

		if (!response.ok) {
			const error = new Error(`Mindkey API request failed with status ${response.status}`) as Error & { statusCode: number };
			error.statusCode = response.status;
			throw error;
		}

		return response.json();
	} catch (error) {
		throw new Error(`Could not get vacancy from Mindkey\nCause: ${error}`, { cause: error });
	}
};

export const getVacanciesFromMindkey = async ({ customerId }: { customerId: string }): Promise<Mindkey.VacancySimple[]> => {
	const url = `${MINDKEY_API_BASE}/${customerId}/vacancies/simple?SortField=EndDate&ShowLocations=true&ShowFieldsOfWork=true`;
	try {
		const response = await fetch(url);

		if (!response.ok) {
			const error = new Error(`Mindkey API request failed with status ${response.status}`) as Error & { statusCode: number };
			error.statusCode = response.status;
			throw error;
		}

		return response.json();
	} catch (error) {
		throw new Error(`Could not get job vacancies \nCause: ${error}`, { cause: error });
	}
};
